import { ButtonProps, IconButton } from '@chakra-ui/react';
import { memo } from 'react';
import { ShareIcon } from 'vectors';

interface Props {
  ariaLabel?: string;
  variant?: ButtonProps['variant'];
  borderRadius?: ButtonProps['borderRadius'];
  size?: ButtonProps['size'];
  ml?: ButtonProps['ml'];
  borderColor?: ButtonProps['borderColor'];
  href?: string;
}

const ShareButton = ({
  variant = 'ghost',
  ariaLabel = 'Share',
  borderRadius,
  size = 'sm',
  ml,
  borderColor,
}: Props) => {
  return (
    <IconButton
      aria-label={ariaLabel}
      variant={variant}
      size={size}
      px={4}
      borderRadius={borderRadius}
      ml={ml}
      borderColor={borderColor}
    >
      Share
      <ShareIcon />
    </IconButton>
  );
};

export default memo(ShareButton);
